import jump from 'jump.js';

const $footer = {
	trigger: document.querySelector('.js-md-PageTop')
};

const $Header = document.querySelector('.js-st-Header');


window.addEventListener('scroll', function(){
	let scroll = document.documentElement.scrollTop;

	if(scroll > 600) {
		$footer.trigger.classList.add('is-show');
		$Header.classList.add('is-active');
	} else {
		$footer.trigger.classList.remove('is-show');
		$Header.classList.remove('is-active');
	}

});

$footer.trigger.onclick = function() {
	jump('body', {
		duration: 500
	});
};
